var _g, _g2, _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCertificates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 270,
    viewBox: "0 0 326 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 71,
    y: 61,
    width: 184,
    height: 148,
    rx: 23,
    stroke: "#065EEA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 48,
    y: 40,
    width: 230,
    height: 190,
    rx: 34,
    stroke: "#065EEA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 26,
    y: 22,
    width: 274,
    height: 226,
    rx: 45,
    stroke: "#065EEA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 1,
    y: 1,
    width: 324,
    height: 268,
    rx: 60,
    stroke: "#065EEA",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5510_25332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 79.4446,
    width: 130,
    height: 98.8889,
    rx: 9.44444,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 79.4446,
    width: 130,
    height: 98.8889,
    rx: 9.44444,
    stroke: "#065EEA",
    strokeWidth: 3.33
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.89 97.2222H160.223C163.291 97.2222 165.778 99.7095 165.778 102.778V153.889C165.778 156.957 163.291 159.444 160.223 159.444H121.89C118.821 159.444 116.334 156.957 116.334 153.889V102.778C116.334 99.7095 118.821 97.2222 121.89 97.2222Z",
    fill: "#D0E2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.611 184.635V174.556C176.611 173.286 177.674 172.274 178.943 172.337L191.443 172.952C192.626 173.01 193.556 173.986 193.556 175.171V185.468C193.556 187.448 191.162 188.44 189.762 187.04L186.238 183.516C185.37 182.648 183.963 182.648 183.096 183.516L180.405 186.206C179.005 187.606 176.611 186.615 176.611 184.635Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.666 141.484V141.484C191.178 140.467 193.155 140.467 194.666 141.484L194.913 141.65C197.324 143.272 200.609 142.462 201.99 139.906V139.906C202.942 138.145 204.865 137.136 206.854 137.353L207.444 137.417M189.666 141.484L189.42 141.65C187.008 143.272 183.724 142.462 182.343 139.906V139.906C181.391 138.145 179.468 137.136 177.479 137.353L176.429 137.467M189.666 141.484V167.548C189.666 168.043 190.265 168.29 190.615 167.94L193.968 164.588M207.444 137.417V137.417C210.017 137.698 212.271 135.7 212.303 133.113L212.31 132.519C212.334 130.518 213.568 128.731 215.431 127.998V127.998C218.135 126.935 219.334 123.773 218.015 121.183V121.183C217.107 119.4 217.368 117.244 218.677 115.73V115.73C220.578 113.532 220.17 110.174 217.799 108.494V108.494C216.166 107.337 215.395 105.307 215.851 103.358V103.358C216.512 100.528 214.591 97.7445 211.71 97.3593V97.3593C209.727 97.094 208.101 95.6538 207.598 93.7165V93.7165C206.869 90.9036 203.874 89.3318 201.145 90.3292V90.3292C199.265 91.0162 197.156 90.4965 195.811 89.0146V89.0146C193.858 86.8629 190.475 86.8629 188.522 89.0146V89.0146C187.177 90.4965 185.068 91.0162 183.188 90.3292V90.3292C180.459 89.3318 177.464 90.9036 176.734 93.7165V93.7165C176.232 95.6538 174.606 97.094 172.622 97.3593V97.3593C169.742 97.7445 167.821 100.528 168.482 103.358V103.358C168.937 105.307 168.167 107.337 166.534 108.494V108.494C164.163 110.174 163.755 113.532 165.655 115.73V115.73C166.964 117.244 167.226 119.4 166.318 121.183V121.183C164.998 123.773 166.198 126.935 168.902 127.998V127.998C170.765 128.731 171.999 130.518 172.023 132.519L172.036 133.575C172.064 135.915 174.103 137.721 176.429 137.467V137.467M207.444 137.417V167.548C207.444 168.043 206.846 168.29 206.496 167.94L199.734 161.179C199.083 160.528 198.028 160.528 197.377 161.179L193.968 164.588M176.429 137.467V189.461C176.429 189.96 177.036 190.206 177.383 189.847L183.374 183.661C184.228 182.779 185.635 182.757 186.517 183.611L193.025 189.92C193.378 190.262 193.968 190.012 193.968 189.521V164.588",
    stroke: "#065EEA",
    strokeWidth: 3.33
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 191.89,
    cy: 115,
    r: 15.5556,
    stroke: "#065EEA",
    strokeWidth: 3.33
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.778 97.2222H121.89C118.821 97.2222 116.334 99.7095 116.334 102.778V153.889C116.334 156.957 118.821 159.444 121.89 159.444H160.778",
    stroke: "#065EEA",
    strokeWidth: 3.33,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.445 110H150.112",
    stroke: "#065EEA",
    strokeWidth: 3.33,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.445 120H150.112",
    stroke: "#065EEA",
    strokeWidth: 3.33,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.445 129.444H150.112",
    stroke: "#065EEA",
    strokeWidth: 3.33,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5510_25332",
    x: 79.8359,
    y: 66.2795,
    width: 206.328,
    height: 175.219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5510_25332"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 20,
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.181042 0 0 0 0 0.369215 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5510_25332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5510_25332",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCertificates);
export default __webpack_public_path__ + "static/media/empty-certificates.378fe3fa45f32be32035ff89550a6cd8.svg";
export { ForwardRef as ReactComponent };